import { render, staticRenderFns } from "./_inventory.vue?vue&type=template&id=1a85da35&scoped=true&"
import script from "./_inventory.vue?vue&type=script&lang=js&"
export * from "./_inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a85da35",
  null
  
)

export default component.exports